// StatusCell.js
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import Swal from 'sweetalert2';
import axios from '../../../utils/axios';

const StatusCell = ({ row, userId, fetchTableData }) => {
  const [status, setStatus] = useState(row.original.accountstatus);
  const [remarks, setRemarks] = useState(row.original.remarks || '');
    row.original.remarks = row.original.remarks? row.original.remarks : '';
  const handleChange = (event) => {
    const newStatus = event.target.value;
    setStatus(newStatus);
    row.original.accountstatus = newStatus;
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
    row.original.remarks = e.target.value? e.target.value : '';
  };

  const handleSave = async () => {
    if (status === "Initiated") {
      Swal.fire({ icon: 'warning', title: 'Cannot Save', text: 'Status cannot be Initiated.' });
      return;
    }
    if (!row.original.receiveddate && status === "Approved" ) {
      Swal.fire({ icon: 'warning', title: 'Missing Date', text: 'Provide Bank Payment Received Date.' });
      return;
    }

   const payload = {
                        forwarderId: row.original.id,
                        userId: userId,
                        cmsfReceivedOnDate: row.original.receiveddate,
                        status: row.original.accountstatus,
                        note: remarks,
                        // bankamountrealized: row.original.bankamountrealized,
                    };
    console.log("payload", payload);

    try {
      const res = await axios.put("/settlement-no/update-forward-letter-info", payload);
      if (res.data?.success) {
        Swal.fire({ icon: 'success', title: res.data.payload[0].status, text: res.data.payload[0].message });
        fetchTableData();
      } else {
        Swal.fire({ icon: 'error', title: res.data?.payload[0]?.status || 'Error', text: res.data?.payload[0]?.message || 'Something went wrong!' });
      }
    } catch (e) {
      console.error(e);
      Swal.fire({ icon: 'error', title: 'Server Error' });
    }
  };

  const bgMap = {
    Initiated: "#0d6efd",
    Pending: "#fd7e14",
    Approved: "#198754",
    Declined: "#dc3545",
  };

  const colorMap = {
    Initiated: "#fff",
    Pending: "#000",
    Approved: "#fff",
    Declined: "#fff",
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={status}
          onChange={handleChange}
          sx={{
            backgroundColor: bgMap[status],
            color: colorMap[status],
            fontWeight: 'bold',
          }}
        >
          <MenuItem disabled={status !== "Initiated"} value="Initiated">Initiated</MenuItem>
          <MenuItem disabled={status === "Approved" || status === "Declined"} value="Pending">Pending</MenuItem>
          <MenuItem value="Approved">Approved</MenuItem>
          <MenuItem disabled={status === "Approved"} value="Declined">Declined</MenuItem>
        </Select>
      </FormControl>

      {(status === "Pending" || status === "Declined") && (
        <input
          type="text"
          placeholder="Remarks"
          value={remarks}
          onChange={handleRemarksChange}
          style={{ marginLeft: '6px', width: '160px' }}
        />
      )}

      <Button
        variant="contained"
        size="small"
        sx={{ ml: 1 }}
        onClick={handleSave}
      >
        Save
      </Button>
    </Box>
  );
};

export default StatusCell;
